import React from "react";
import Navbar from "./Navbar";
const Header = () => {
  return (
    <div className="sticky top-0 bg-white z-10">
      <Navbar />
    </div>
  );
};

export default Header;
